// Группы алиасов, которые бэк возвращает в разных регистрах.
// Канонический ключ — первый элемент массива (используется в новом коде).
// При нормализации значение зеркалится во все алиасы из группы,
// чтобы и старые читатели (item.orgname, item.OrgName, ...), и новые (item.orgName)
// работали одинаково.
const ALIAS_GROUPS = [
  ['orgName', 'orgname', 'Orgname', 'OrgName'],
  ['idOrganization', 'idorganization', 'IdOrganization'],
]

export function normalizeAliases(node) {
  if (node === null || typeof node !== 'object') return node

  if (Array.isArray(node)) {
    for (const item of node) normalizeAliases(item)
    return node
  }

  for (const aliases of ALIAS_GROUPS) {
    let value
    let found = false
    for (const key of aliases) {
      if (key in node && node[key] !== undefined && node[key] !== null) {
        value = node[key]
        found = true
        break
      }
    }
    if (found) {
      for (const key of aliases) {
        if (node[key] === undefined || node[key] === null) node[key] = value
      }
    }
  }

  for (const key in node) normalizeAliases(node[key])
  return node
}
